import { useMemo } from 'react';

/* eslint-disable @typescript-eslint/ban-types */
const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const defaultFilter = (value, _, matcher) => value && typeof value === 'string' && matcher.test(value);
const useColumnFilters = (columns) => {
    return useMemo(() => {
        const columnFilters = columns
            .filter(column => !column.disableGlobalFilter)
            .reduce((filters, { accessor, searchFilter }) => {
            const filter = searchFilter || defaultFilter;
            if (typeof accessor === 'string') {
                filters[accessor] = filter;
            }
            return filters;
        }, {});
        const globalFilter = (rows, _, filterValue) => {
            if (filterValue) {
                const escapedValue = escapeRegExp(filterValue);
                return rows.filter(row => Object.entries(row.values).some(([id, value]) => {
                    if (columnFilters[id]) {
                        return columnFilters[id](value, filterValue, new RegExp(escapedValue, 'ig'));
                    }
                    return false;
                }));
            }
            return rows;
        };
        return { filterTypes: { globalFilter }, globalFilter: 'globalFilter' };
    }, [columns]);
};

export { useColumnFilters as default };
//# sourceMappingURL=useColumnFilters.js.map
